import AuthDrawer from "../../components/AuthDrawer";
import {
    FormControl,
    MenuItem, Select,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import Loading from "../../components/Loading";
import {useState, useEffect} from "react";
import {useHistory} from "react-router-dom";
import useCallDataApi from "../../hooks/data";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {hu} from "date-fns/locale";
import {format} from "date-fns";
import thousandSeparator from "../../utils/NumberUtils";
import DinoDataGrid from "../../components/DataGrid";
import {GridActionsCellItem} from "@mui/x-data-grid";
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';


const PartnerEffectiveness = () => {
    const queryParams = JSON.parse(localStorage.getItem('partnerQuery') || "{}")
    const today = new Date()
    const {postData: postPartners} = useCallDataApi('partners')
    const [compare, setCompare] = useState(null)
    const [loading, setLoading] = useState(true)
    const [partners, setPartners] = useState({'uf_data': []})
    const [fromDate, setFromDate] = useState(new Date(queryParams?.start_date ? queryParams?.start_date : `${today.getFullYear()}-01-01`))
    const [endDate, setEndDate] = useState(queryParams?.end_date ? new Date(queryParams?.end_date) : today)
    const [selectedMode, setSelectedMode] = useState(queryParams?.mode || 'person')
    const history = useHistory()
    document.title = 'Ügyfél eredményesség'

    const columns = [
        {
            field: "manage",
            headerName: "Manage",
            sortable: false,
            type: "actions",
            getActions: (params) => [<GridActionsCellItem
                icon={<DoneIcon/>}
                onClick={() => {
                    setCompare(params.row.id)
                }}
                label="Kiválasztás összehasonlításhoz"
                showInMenu={true}
            />, <GridActionsCellItem
                icon={<DoneAllIcon/>}
                onClick={() => {
                    history.push(`/partner-compare/${compare}/${params.row.id}`)
                }}
                label="Összehasonlítás a kiválasztottal"
                showInMenu={true}
            />
        ]},
        {headerName: 'Név', field: 'uf_name', width: 300},
        {headerName: 'Forgalom', field: 'traffic', width: 140, renderCell: p => thousandSeparator(p.row.traffic) + ' Ft'},
        {headerName: 'Árrés', field: 'margin', width: 140, renderCell: p => thousandSeparator(p.row.margin) + ' Ft'},
        {headerName: 'Forgalom arányos árrés', field: 'margin_percentage', width: 100, valueGetter: p => Math.round(p?.row?.margin_percentage * 1000) / 1000, renderCell: p => (p.row.margin_percentage + ' %')},
        {headerName: 'Darabszám', field: 'count', width: 100},
    ]

    const getPartners = () => {
        setLoading(true)
        postPartners(`paginated_partners`, {
            start_date: format(fromDate, 'yyyy-MM-dd'),
            end_date: format(endDate, 'yyyy-MM-dd'),
            mode: selectedMode,
        })
            .then(p => {
                setPartners(p)
            })
            .catch(e => {
                setPartners({'uf_data': []})
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        getPartners()
        localStorage.setItem('partnerQuery', JSON.stringify({
            start_date: format(fromDate, 'yyyy-MM-dd'),
            end_date: format(endDate, 'yyyy-MM-dd'),
            mode: selectedMode,
        }))
    }, [fromDate, endDate, selectedMode])


    const Search = () => {
        return <Stack direction='row' alignItems='center' gap={2}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={hu}>
                <Stack spacing={2} direction='row' alignItems='center'>
                    <DatePicker
                        inputFormat="yyyy-MM-dd"
                        mask='____-__-__'
                        value={fromDate}
                        onChange={(v) => setFromDate(v)}
                        renderInput={(params) => <TextField name='from_date' variant='standard' {...params} />}
                    />
                    <Typography variant='body1' color='#38556A'>-</Typography>
                    <DatePicker
                        inputFormat="yyyy-MM-dd"
                        mask='____-__-__'
                        value={endDate}
                        onChange={(v) => setEndDate(v)}
                        renderInput={(params) => <TextField name='until_date' variant='standard' {...params} />}
                    />
                </Stack>
            </LocalizationProvider>
            <FormControl>
                <Select
                    id="company-select"
                    value={selectedMode}
                    onChange={e => setSelectedMode(e.target.value)}
                    variant='standard'
                >
                    <MenuItem value='person'>Magánszemélyek</MenuItem>)
                    <MenuItem value='non-person'>Cégek</MenuItem>)
                    {/*<MenuItem value='company-group'>Cégcsoport</MenuItem>)*/}
                </Select>
            </FormControl>
        </Stack>
    }


    return <AuthDrawer label='Ügyfél eredményesség'>
        <Stack direction='row' justifyContent='space-between'
               sx={{background: '#fff', borderRadius: '8px', padding: '5px'}} marginBottom={2}>
            {Search()}
        </Stack>

        {partners?.uf_data?.length === 0 ? <Stack alignItems='center' justifyContent='center' marginBottom={2}>
            <Typography align='center' variant='h5' color='#ababab'>Nincsenek partnerek ebben az időszakban!</Typography>
        </Stack> : <Stack alignItems='center' spacing={3} justifyContent='center' marginBottom={2} direction='row'>
            <Typography align='center' variant='h5' color='#ababab'>Össz forgalom: {thousandSeparator(partners?.total_traffic)} Ft</Typography>
            <Typography align='center' variant='h5' color='#ababab'>Össz árrés: {thousandSeparator(partners?.total_margin)} Ft</Typography>
        </Stack>}
        <DinoDataGrid rows={partners?.uf_data} columns={columns} onRowClick={p => {
            history.push(`/partner-effectiveness/${p?.id}`)
        }}/>


        <Loading isLoading={loading}/>
    </AuthDrawer>
}

export default PartnerEffectiveness